export default __webpack_public_path__ + "static/media/content.11784dfb.png";